/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { ChatAgentPersona } from './ChatAgentPersona';
import {
    ChatAgentPersonaFromJSON,
    ChatAgentPersonaFromJSONTyped,
    ChatAgentPersonaToJSON,
    ChatAgentPersonaToJSONTyped,
} from './ChatAgentPersona';

/**
 * 
 * @export
 * @interface WsMember
 */
export interface WsMember {
    /**
     * Unique identifier of the workspace member record
     * @type {string}
     * @memberof WsMember
     */
    id: string;
    /**
     * The user associated with this workspace member
     * @type {User}
     * @memberof WsMember
     */
    user: User;
    /**
     * The chat agent persona for this member, if any
     * @type {ChatAgentPersona}
     * @memberof WsMember
     */
    persona?: ChatAgentPersona;
    /**
     * The role of this member in the workspace
     * @type {string}
     * @memberof WsMember
     */
    role: WsMemberRoleEnum;
}


/**
 * @export
 */
export const WsMemberRoleEnum = {
    Owner: 'OWNER',
    BillingManager: 'BILLING_MANAGER',
    Member: 'MEMBER'
} as const;
export type WsMemberRoleEnum = typeof WsMemberRoleEnum[keyof typeof WsMemberRoleEnum];


/**
 * Check if a given object implements the WsMember interface.
 */
export function instanceOfWsMember(value: object): value is WsMember {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function WsMemberFromJSON(json: any): WsMember {
    return WsMemberFromJSONTyped(json, false);
}

export function WsMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): WsMember {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user': UserFromJSON(json['user']),
        'persona': json['persona'] == null ? undefined : ChatAgentPersonaFromJSON(json['persona']),
        'role': json['role'],
    };
}

export function WsMemberToJSON(json: any): WsMember {
    return WsMemberToJSONTyped(json, false);
}

export function WsMemberToJSONTyped(value?: WsMember | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user': UserToJSON(value['user']),
        'persona': ChatAgentPersonaToJSON(value['persona']),
        'role': value['role'],
    };
}

